exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mybets-container{font-size:1.25rem}.mybets-container h4{font-weight:400;text-transform:uppercase;font-size:2rem}.mybets-container .panel-body{background:#fff;color:#767676}.mybets-container table th{text-transform:uppercase}.mybets-container table th:hover{cursor:pointer}.mybets-container table tr.info td{background:#fff}.mybets-container table tr.success td{background:#dff0d8}.mybets-container table tr.danger td{background:#f2dede}.mybets-container table tr.warning td{background:#fcf8e3}.mybets-container table tr td{cursor:pointer}.mybets-container table tr td .col-xs-12{padding-right:0;padding-left:0}.mybets-container table tr .odds-cell,.mybets-container table tr .return-cell{font-weight:800}.mybets-container table tr .bookmaker-cell{text-transform:uppercase}.mybets-container .pagination{margin-left:auto;margin-right:auto}#custom-bet{margin-left:20px;margin-right:-17px}#title{margin-left:-9px}.custom-bet-form{font-size:1.5rem!important}.custom-bet-form .form-group{margin-bottom:5px}.custom-bet-form .form-control{font-size:1.5rem!important}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/css/mybets.less
 ** module id = 781
 ** module chunks = 0
 **/